import React from 'react';
import { colors } from '../constants';

const KanbanIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="48px"
        viewBox="0 -960 960 960"
        width="48px"
        fill={colors.charcoal}
    >
        <path d="M400-240v-60h160v60H400ZM240-450v-60h480v60H240ZM120-660v-60h720v60H120Z" />
    </svg>
);

export default KanbanIcon;
